import * as React from 'react';
import * as w from '@packages/systems/wfdl';
import * as wast from '@packages/systems/wfdl-ast';
import {
  TSecretApiToken,
  TSecretUserAndPass,
} from '@packages/systems/plugins/Secret';
import {AUTHENTICATION} from '@packages/systems/flows/shared';
import {ExpressionEditor} from '@packages/systems/ExpressionEditor-utils';
import {qualify, pluginName, typeName} from '@packages/systems/wfdl-Qualified';

const PrivateTRecord = w.withSystem(
  {private: true, bindUIVariant: 'custom'},
  wast.TEmptyRecord
);

const AuthenticationType = w.withSystem(
  {isFullWidth: true, bindUIVariant: 'custom'},
  w.withMeta(
    {variant: 'menu'},
    wast.TUnion({
      [AUTHENTICATION.TYPE.NONE]: PrivateTRecord,
      [AUTHENTICATION.TYPE.API_TOKEN]: wast.TRecord({
        [AUTHENTICATION.API_TOKEN.ADD_TO]: w.withSystem(
          {
            defaultValue: AUTHENTICATION.ADD_TO.HEADER,
            isFullWidth: true,
            bindUIVariant: 'custom',
          },
          w.withMeta(
            {variant: 'menu'},
            wast.TUnion({
              [AUTHENTICATION.ADD_TO.HEADER]: w.withSystem(
                {
                  isFullWidth: true,
                  labelVariant: 'hidden',
                  bindUIVariant: 'custom',
                  isBindable: false,
                },
                wast.TTypeConstructor(
                  qualify(
                    pluginName('Http'),
                    typeName('Request Authentication Header')
                  )
                )
              ),
              [AUTHENTICATION.ADD_TO.QUERY_PARAMS]: w.withSystem(
                {
                  isFullWidth: true,
                  labelVariant: 'hidden',
                  bindUIVariant: 'custom',
                  isBindable: false,
                },
                wast.TTypeConstructor(
                  qualify(
                    pluginName('Http'),
                    typeName('Request Authentication Query Parameter')
                  )
                )
              ),
            })
          )
        ),
        [AUTHENTICATION.SHARED.CREDENTIAL]: w.withSystem(
          {
            label: 'Credential',
            labelVariant: 'hidden',
            bindUIVariant: 'custom',
          },
          TSecretApiToken
        ),
      }),
      [AUTHENTICATION.TYPE.USERNAME_AND_PASSWORD]: w.withSystem(
        {label: 'Credential', labelVariant: 'hidden'},
        TSecretUserAndPass
      ),
    })
  )
);

export const RequestAuthenticationType = w.TypeImplementation.Alias({
  type: AuthenticationType,
  render: function RenderAuthentication({expr, dispatch}) {
    return <ExpressionEditor dispatch={dispatch} expression={expr} />;
  },
});
